export const SUBMIT_LOADING_LIST_SURVEY = "SUBMIT_LOADING_LIST_SURVEY"
export const UPDATE_LIST_DATA_LIST_SURVEY = "UPDATE_LIST_DATA_LIST_SURVEY"
export const UPDATE_PAGINATION_LIST_SURVEY = "UPDATE_PAGINATION_LIST_SURVEY"
export const UPDATE_DUPLICATE_STATUS_LIST_SURVEY = "UPDATE_DUPLICATE_STATUS_LIST_SURVEY"
export const UPDATE_SURVEY_LIST_REQUEST = "UPDATE_SURVEY_LIST_REQUEST"
export const CLEAR_SURVEY_LIST_REQUEST = "CLEAR_SURVEY_LIST_REQUEST"